module.exports = __webpack_public_path__ + "img/button_next_bottom_inactive.a9409bb0.svg";